import {I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from "lf-at-theme";

/**
 * Intermediary form i18n object for the pt-PT locale.
 */

export const intermediaryFormI18nPtPT: Record<string, any> = {
  '/intermediary-form': {
    label: 'Registo como Intermediário',
  },

  '/?/meetsConditions': {
    label: 'Confirmo que reúno as condições para me registar neste regime.'
  },


  '/?/currVatId': {
    netpVat: 'Número de Intermediário',
    netpHelp: 'Número de identificação individual atribuído pelo Estado-Membro de identificação nos termos do artigo 369.o-Q, n.o 2, da Diretiva 2006/112/CE',
  },
  '/?/currVatId/vatIdNum': {
    legend: 'Preenchido pelo sistema após aprovação'
  },

  '/?/identificationOfBusiness': {
    label: 'Numero de Identificação Fiscal',
  },
  '/?/identificationOfBusiness/issuingCountry': {
    [I18N_VALUE_CODE_KEY]: '2a',
  },
  '/?/identificationOfBusiness/vatIdNum': {
    legend: 'Preenchido pelo sistema'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'O Estado-Membro em que o intermediário tem a sua sede ou, na falta de sede na União, o Estado-Membro em que o intermediário dispõe de um estabelecimento estável, caso indique que utilizará o regime de importação em nome do(s) sujeito(s) passivo(s) que representa'
  },

  '/?/contactInfo/email': {
    label: 'Endereço de correio eletrónico do intermediário'
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual IVA ou, se não existir(em), número(s) de identificação fiscal atribuído(s) pelo(s) Estado-Membro(s) em que o intermediário dispõe de estabelecimento(s) estável(is) que não seja(m) o Estado-Membro de identificação.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número de identificação fiscal atribuído pelo Estado-Membro'
  },

  '/?/prevOrCurrOssVatId': {
    headerText: 'Registo como Intermediário noutros Estados-Membros',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de intermediário atribuído(s) pelo Estado-Membro de identificação nos termos do artigo 369.o-Q, n.o 2, da Diretiva 2006/112/CE'
  },

  '/?/relevantDates/registrationReqDate': {
    label: 'Data do pedido de registo como intermediário',
    [I18N_VALUE_HELP_MESSAGE_KEY]: null
  },
};
